/* eslint-disable @typescript-eslint/no-explicit-any */
// src/constants/iconMap.tsx
import React from 'react';
import * as AntIcons from '@ant-design/icons';
import {
  SettingOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  LinkOutlined,
  LockOutlined,
  ApartmentOutlined,
  AppstoreOutlined,
  DesktopOutlined,
  KeyOutlined,
  BookOutlined,
  FileTextOutlined,
  AuditOutlined,
  BankOutlined,
  SearchOutlined,
  FileAddOutlined,
  FileDoneOutlined,
  SafetyOutlined,
  GlobalOutlined,
  UploadOutlined,
  CreditCardOutlined,
  RocketOutlined,
  UnlockOutlined,
  FileOutlined,
  DollarOutlined,
  SwapOutlined,
  PlusSquareOutlined,
  EditOutlined,
  FundOutlined,
  CheckOutlined,
  ThunderboltOutlined,
  ToolOutlined,
  ApiOutlined,
  ScheduleOutlined,
  FileExcelOutlined,
} from '@ant-design/icons';

export const iconMap: Record<string, JSX.Element> = {
  SettingOutlined: <SettingOutlined />,
  TeamOutlined: <TeamOutlined />,
  UnorderedListOutlined: <UnorderedListOutlined />,
  LinkOutlined: <LinkOutlined />,
  LockOutlined: <LockOutlined />,
  ApartmentOutlined: <ApartmentOutlined />,
  AppstoreOutlined: <AppstoreOutlined />,
  DesktopOutlined: <DesktopOutlined />,
  KeyOutlined: <KeyOutlined />,
  BookOutlined: <BookOutlined />,
  FileTextOutlined: <FileTextOutlined />,
  AuditOutlined: <AuditOutlined />,
  BankOutlined: <BankOutlined />,
  SearchOutlined: <SearchOutlined />,
  FileAddOutlined: <FileAddOutlined />,
  FileDoneOutlined: <FileDoneOutlined />,
  SafetyOutlined: <SafetyOutlined />,
  GlobalOutlined: <GlobalOutlined />,
  UploadOutlined: <UploadOutlined />,
  CreditCardOutlined: <CreditCardOutlined />,
  RocketOutlined: <RocketOutlined />,
  UnlockOutlined: <UnlockOutlined />,
  FileOutlined: <FileOutlined />,
  DollarOutlined: <DollarOutlined />,
  SwapOutlined: <SwapOutlined />,
  PlusSquareOutlined: <PlusSquareOutlined />,
  EditOutlined: <EditOutlined />,
  FundOutlined: <FundOutlined />,
  CheckOutlined: <CheckOutlined />,
  ThunderboltOutlined: <ThunderboltOutlined />,
  ToolOutlined: <ToolOutlined />,
  ApiOutlined: <ApiOutlined />,
  ScheduleOutlined: <ScheduleOutlined />,
  FileExcelOutlined: <FileExcelOutlined />,
};

// ---- Fallback dinâmico ----
const NBSP = /\u00A0/g; // limpa non-breaking space

const SUFFIXES = ['Outlined', 'Filled', 'TwoTone'] as const;

function toPascalCase(raw: string): string {
  return raw
    .replace(NBSP, ' ')
    .replace(/[_\-\s]+/g, ' ')
    .trim()
    .split(' ')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join('');
}

function ensureSuffix(name: string, suffix: typeof SUFFIXES[number]) {
  return SUFFIXES.some((s) => name.endsWith(s)) ? name : name + suffix;
}

/** Tenta resolver qualquer nome de ícone exportado por @ant-design/icons */
export function resolveIconDynamic(name?: string): JSX.Element | undefined {
  if (!name) return undefined;

  const lib = AntIcons as unknown as Record<
    string,
    React.ComponentType<any> | undefined
  >;
  const base = name.replace(NBSP, ' ').trim();

  // tira sufixo pra normalizar e montar candidatos
  const baseNoSuffix = base.replace(/(Outlined|Filled|TwoTone)$/i, '');
  const pascal = toPascalCase(baseNoSuffix);

  const candidates = Array.from(
    new Set<string>([
      base, // "AlignLeftOutlined"
      ensureSuffix(base, 'Outlined'), // "AlignLeft" -> "AlignLeftOutlined"
      ensureSuffix(pascal, 'Outlined'), // "align-left" -> "AlignLeftOutlined"
      ensureSuffix(pascal, 'Filled'),
      ensureSuffix(pascal, 'TwoTone'),
    ])
  );

  for (const key of candidates) {
    const Comp = lib[key];
    if (Comp) return <Comp />;
  }

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn('[iconMap] Icon not found:', name, 'candidates:', candidates);
  }
  return undefined;
}
